import React from "react";
import "./box_text_slide_image_group.scss";
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import {Col, Container, Row} from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MainParagraph from "../../common_components/main_paragraph/main_paragraph";
import LuissButton from "../../common_components/luiss_button/luiss_button";
import TemplatePagePlaceholder from "../../containers/template_page/template_page_placeholder/template_page_placeholder";


class BoxTextSliderImgGroup extends TemplateComponent {
    private vidRef: React.RefObject<any>;
    constructor(props: TemplateComponentProps) {
        super(props);
        this.vidRef = React.createRef();
        this.state = {
            slideIndex: 1,
            updateCount: 0,
            isHidden: false,
            playing: false
        }
    }
    playVideo = () => {
        this.vidRef.current.play();
        this.setState({
            isHidden: true,
            playing:true
        })
    };
    
    private slider: any;

    componentRender(data: { carousel_items: {
            length: 0;
            map: (arg0: (item: any, index: any) => JSX.Element) => React.ReactNode;
    };
        title: React.ReactNode;
        subtitle: React.ReactNode;
        btn_link?: void;
        btn_title?: React.ReactNode;
        video?: React.ReactNode;
        image?: React.ReactNode;
    }) {
        const thisType = this;
        const settings = {
            vertical:true,
            verticalSwiping:true,
            centerPadding: '0px',
            className: "center",
            centerMode: true,
            infinite: true,
            slidesToShow: 1,
            speed: 200,
            arrows:false,
            swipeToSlide: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        vertical:false,
                        verticalSwiping:false
                    }
                }
            ],
            afterChange: (index: number) => thisType.setState((state: { updateCount: number; }) => ({ slideIndex: state.updateCount + (index + 1) })),
            beforeChange: (current: any, next: any) => this.setState({ slideIndex: next })
        };

        // calc the length of carousel items
        const len = data.carousel_items.length;

        return (

            <div id="box-text-slider-image-group">
                <Container fluid={true} className="image-text-button">
                    <Slider ref={slider => (this.slider = slider)} {...settings}>
                        
                        {data.carousel_items.map((item, index) => (

                            <div key={index} className="img-container">

                                <Row>
                                    <Col className="image-col">

                                        {/*check if there is video, also show image*/}
                                        {(item.image && !item.video) ?
                                            <img src={item.image} alt={item.title} className={'slider-cta-image'}/>
                                        : null}
                                        {(item.video) ?
                                            <TemplatePagePlaceholder image={(item.image) ? item.image: null} video={item.video}/>
                                        : null}

                                    </Col>
                                    <Col className="wrap-content">
                                        <div className={"progress-slide"}>
                                            <span>{this.state.slideIndex}</span><span>/{len}</span>
                                        </div>
                                        <div className="right-content">
                                            <MainParagraph title={item.title} text={item.subtitle} />
                                            {(item.btn_link)?<LuissButton url={item.btn_link}>{item.btn_title}</LuissButton>:null}
                                        </div>
                                    </Col>
                                </Row>

                            </div>
                        ))}
                    </Slider>
                </Container>
            </div>
        )
    }
}

export default BoxTextSliderImgGroup;


